import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import "../App.css";

const Navbar = () => {
  return (
    <Fragment>
      <div className="Container-fluid">
        <header class=" sticky-top site-header d-flex flex-wrap justify-content-center py-3 mb-4 border-bottom ">
          <a
            href="/"
            class="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-dark text-decoration-none"
          >
            <img
              class="bi me-2"
              width="32"
              height="32"
              src="./assest/Logos.png"
              alt="logo"
            />
            <span class="fs-4">
              <Link className="nav-link" to="/">
                Nepa Youth Club
              </Link>
            </span>
          </a>

          <ul class="nav nav-pills">
            <li class="nav-item">
              <Link class="nav-link " to="/" aria-current="page">
                Home
              </Link>
            </li>
            <li class="nav-item">
              <Link className="nav-link" to="/news">
                News
              </Link>
            </li>
            <li class="nav-item">
              <Link className="nav-link" to="/contact">
                Contact us
              </Link>
            </li>
            <li class="nav-item">
              <Link className="nav-link" to="/about">
                About
              </Link>
            </li>
            <li class="nav-item">
              <Link className="nav-link" to="/FAQ">
                FAQs
              </Link>
            </li>
          </ul>
        </header>
      </div>
    </Fragment>
  );
};

export default Navbar;
